import { Box, Flex, Heading } from '@chakra-ui/react';
import { ContractQuery } from 'generated/graphql';
import DocumentListItem from './DocumentListItem';

type Document = NonNullable<ContractQuery['contract']['documents']['edges'][number]['node']>;
interface Props {
  documents: Document[];
}

function DocumentList({ documents }: Props) {
  return (
    <Box borderRight="1px" borderColor="gray.200" pr={3}>
      <Flex justify="space-between" align="center">
        <Heading as="h2">Your Contract</Heading>
      </Flex>
      <Box mt={4}>
        {documents.map(document => (
          <DocumentListItem key={document.id} document={document} />
        ))}
      </Box>
    </Box>
  );
}

export default DocumentList;
